import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
@Component({
  selector: 'app-flights-search-bar',
  templateUrl: './flights-search-bar.component.html',
  styleUrls: ['./flights-search-bar.component.scss']
})
export class FlightsSearchBarComponent {
  @Output() onsearch: EventEmitter<any> = new EventEmitter();
  trip_type: string = 'RoundTrip';
  @Input() id: number = 0;
  flights: any;
  activeTripType: any;

  constructor(
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.syncTripType(this.route.snapshot.queryParams);
    this.route.queryParams.subscribe((res: any) => {
      this.syncTripType(res);
    });
  }

  private syncTripType(params: any): void {
    const searchType = params?.search_type || this.trip_type || 'RoundTrip';
    const flights = params?.flights ? JSON.parse(params.flights) : null;

    this.trip_type = searchType;
    this.flights = flights;

    // if (this.trip_type === 'OneWay' && this.flights?.length === 2) {
    //   this.trip_type = 'RoundTrip';
    // }
  }

  search(event: any) {
    this.onsearch.emit(event);
  }
}
